import serverContext from "@/core/server-context";

export interface DropRouteLeg {
    steps: google.maps.LatLngLiteral[];
    duration: number;   // Seconds
}

export interface RoutesRequest {
    origin: RouteApiRequestLocation;
    destination: RouteApiRequestLocation;
    travelMode: "DRIVE" | "TRANSIT" | "TRAVEL_MODE_UNSPECIFIED";
    routingPreference?: "TRAFFIC_AWARE" | "SHORTEST";
    computeAlternativeRoutes?: boolean;
    routeModifiers?: RouteModifiers;
    units: "IMPERIAL" | "METRIC";
    intermediates: RouteApiRequestLocation[] | undefined;
}

export interface RouteApiRequestLocation {
    location: LocationLatLng;
}

export interface LocationLatLng {
    latLng: {latitude: number, longitude: number};
}

export interface RouteModifiers {
    avoidTolls: boolean;
    avoidHighways: boolean;
    avoidFerries: boolean;
}

export const ROUTES_URL = "https://routes.googleapis.com/directions/v2:computeRoutes";

export const ROUTES_HEADERS = {
    "Content-Type": "application/json",
    "X-Goog-Api-Key": serverContext.googleMapsApiKey,
    "X-Goog-FieldMask": "routes.legs.duration,routes.legs.steps.polyline,routes.legs.steps.startLocation,routes.legs.steps.endLocation"
};
